import Stickyfill from 'stickyfilljs';
import {
  BackgroundVideo,
  Collapse,
  helpers,
  Modal,
  Panel,
  phoneField,
  PhxToaster,
  slider,
  VideoPlayer,
} from '@phx-styleguides/iwc';

import { patchedLoadingState } from '@sg-core/resources/assets/js/patches/buttons';
import { AnimateGroupReveal } from '@sg-core/resources/assets/js/animations';

import { CardExpandable } from '@sg/src/View/Components/Molecules/Card/card-expandable';

const patchedHelpers = {
  ...helpers,
  buttons: {
    ...helpers.buttons,
    addLoadingState: patchedLoadingState(helpers.buttons.addLoadingState),
    removeLoadingState: patchedLoadingState(helpers.buttons.removeLoadingState),
  },
};

export {
  AnimateGroupReveal,
  BackgroundVideo,
  CardExpandable,
  Collapse,
  patchedHelpers as helpers,
  Modal,
  Panel,
  phoneField,
  PhxToaster,
  Stickyfill,
  slider,
  VideoPlayer,
};
